import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { MenuDataLocaleContext } from "../../menudata/context/MenuDataLocaleContext";
import { getGuestPlatformFeeEnabled } from "../../order/selectors/restaurantFlags";
import { getProcessingFeeDisclaimerText } from "../util/getProcessingFeeDisclaimerText";

export const ProcessingFeeDisclaimer = () => {
    const menuDataLocale = useContext(MenuDataLocaleContext);
    const guestPlatformFeeEnabled = useSelector(getGuestPlatformFeeEnabled);

    return <>{getProcessingFeeDisclaimerText(menuDataLocale, guestPlatformFeeEnabled)}</>;
};
